import { Injectable }    from '@angular/core';
import { environment } from 'src/environments/environment';
import {RequestItemsListViewModel, SearchModel, SearchResultModel} from 'src/common';
import {HttpClient} from '@angular/common/http';
import {RequestItemsLegalTermListModel} from "./request-items-legal-term-list.model";



const localApiUrl = `${environment.apiUrl}/RequestItemsLegalTermList`;

@Injectable()
export class RequestItemsLegalTermListService {

  constructor(private http: HttpClient) { }

  search(search: SearchModel): Promise<SearchResultModel<RequestItemsLegalTermListModel>> {
      return this.http.post<SearchResultModel<RequestItemsLegalTermListModel>>(`${localApiUrl}/Search`, search).toPromise();
  }

  getAll(): Promise<RequestItemsLegalTermListModel[]> {
	return this.http.get<RequestItemsLegalTermListModel[]>(`${localApiUrl}/All`).toPromise();
  }

  getById(id: number): Promise<RequestItemsLegalTermListModel> {
    return this.http.get<RequestItemsLegalTermListModel>(`${localApiUrl}/Details/${id}`).toPromise();
  }

  delete(id: number): Promise<void> {
	return this.http.get<void>(`${localApiUrl}/Delete/${id}`).toPromise();
  }

  save(model: any): Promise<void> {
    return this.http.post<void>(`${localApiUrl}/Save`, model).toPromise();
  }


  // custom-start

  getLegalTermsForInput(requestId): Promise<RequestItemsLegalTermListModel[]> {
    return this.http.get<RequestItemsLegalTermListModel[]>(`${environment.apiUrl}/SupplierOffer/GetLegalTermsForInput?requestId=${requestId}`).toPromise();
  }


  getLegalTerms(supplierOfferId): Promise<RequestItemsLegalTermListModel[]> {
    let url = `${environment.apiUrl}/SupplierOffer/SupplierOfferLegalTermsElements?supplierOfferId=${supplierOfferId}`;

    return this.http.get<RequestItemsLegalTermListModel[]>(url).toPromise();
  }


  saveOfferLegalTerms(model: any): Promise<void> {
    return this.http.post<void>(`${environment.apiUrl}/SupplierOffer/SaveOfferLegalTerms`, model).toPromise();
  }

  // custom-end

}



